module.exports = __webpack_public_path__ + "static/media/aboutPhoto.715f300d.jpg";